import { lazy } from 'react';
import { EnumBehaviorKey } from 'src/types/Behaviors';
import { AppRoute } from 'src/types/Route';

const PermissionColumn = lazy(
  () =>
    import(
      /* webpackChunkName: "PermissionColumn" */ 'src/pages/Backstage/subPages/UserPermission/PermissionColumn'
    ),
);

const PermissionRow = lazy(
  () =>
    import(
      /* webpackChunkName: "PermissionRow" */ 'src/pages/Backstage/subPages/UserPermission/PermissionRow'
    ),
);

const PermissionDataset = lazy(
  () =>
    import(
      /* webpackChunkName: "PermissionDataset" */ 'src/pages/Backstage/subPages/UserPermission/PermissionDataset'
    ),
);

const dataPermissionRoutes: AppRoute[] = [
  {
    name: '数据集权限',
    path: '/backstage/user-permission/permission-dataset',
    Component: PermissionDataset,
    behaviors: [EnumBehaviorKey.ANALYZE_PERMISSION_MANAGE],
  },
  {
    name: '行级权限',
    path: '/backstage/user-permission/permission-row',
    Component: PermissionRow,
    behaviors: [EnumBehaviorKey.ANALYZE_PERMISSION_MANAGE],
  },
  {
    name: '列级权限',
    path: '/backstage/user-permission/permission-column',
    Component: PermissionColumn,
    behaviors: [EnumBehaviorKey.ANALYZE_PERMISSION_MANAGE],
  },
  // 必须放在角色数据权限查询前面，不然不生效
  {
    name: '详情',
    path: '/backstage/user-permission/permission-search/detail',
    Component: lazy(
      () =>
        import(
          /* webpackChunkName: "PermissionSearchDetail" */ 'src/pages/Backstage/subPages/UserPermission/PermissionSearch/subPages/detail/index'
        ),
    ),
    hideInPanel: true,
    behaviors: [EnumBehaviorKey.ANALYZE_PERMISSION_MANAGE],
  },
  {
    name: '角色数据权限查询',
    path: '/backstage/user-permission/permission-search',
    Component: lazy(
      () =>
        import(
          /* webpackChunkName: "PermissionSearch" */ 'src/pages/Backstage/subPages/UserPermission/PermissionSearch'
        ),
    ),
    behaviors: [EnumBehaviorKey.ANALYZE_PERMISSION_MANAGE],
  },
];

export default dataPermissionRoutes;
